import { sessionIdsQuery } from '../load/useSessionIdsFromUrl'

export const sessionAnalysisPath = (sessionIds: string[]): string =>
  `/v2/analysis/sessions?${sessionIdsQuery(sessionIds)}`
